import { useEffect, useState, useRef } from "react";
import Select from "react-select";
import uuid from "react-uuid";
import { useHistory } from "react-router-dom";
import useMessage from "hooks/useMessage";
import Attachments from "components/Attachment/Attachment";
import ToolTip from "components/ToolTip/ToolTip";
import IconButton from "components/IconButton/IconButton";
import { CompaniaManager, SolicitudCompaniaTenantManager as SolicitudManager, SeguridadManager } from "managers";
import useExceptionHandler from "hooks/useExceptionHandler";
import { DateHelper, DEFAULT_PAGINATION_VALUES, FORMAS_PAGO, ESTATUS_TERMINAL } from "utils";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import { useAuthentication } from "hooks";
import useQueryParams from "hooks/useQueryParams";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import ListHeader from "components/PantallaList/Header/ListHeader";
import { EditSection } from "components/MiCuenta/EditSection/EditSection";
import { Form, Row } from "react-bootstrap";
import { Permisos } from "utils/permisos";
import { Compania } from "models/Compania";
import {
  SolicitudesCompaniaTenant,
  TIPO_SOLICITUD_CANCELACION_LABEL,
  TIPO_SOLICITUD_ACTIVACION_LABEL,
  TIPO_SOLICITUD_REACTIVACION_LABEL,
  ESTATUS_PENDIENTE,
  ESTATUS_PENDIENTE_LABEL,
  ESTATUS_RECHAZADO,
  ESTATUS_RECHAZADO_LABEL,
  ESTATUS_APROBADO,
  ESTATUS_APROBADO_LABEL
}
  from "models/SolicitudesCompaniaTenant"
import ModalContainer from "components/ModalContainer/ModalContainer";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import {
  GridView,
  InputSidebarContainer,
  SvgComponent,
  Simplebar,
} from "components";

const ESTATUS_SOLICITUD_TENANT_LIST = [{ value: "", label: "Todos" }, ...SolicitudesCompaniaTenant.ESTATUS_SOLICITUD_TENANT];
const TIPO_SOLICITUD_TENANT_LIST = [{ value: "", label: "Todos" }, ...SolicitudesCompaniaTenant.TIPO_SOLICITUD_TENANT];
const ESTATUS_COMPANIA_BLOQUEAR = "B"
const ESTATUS_COMPANIA_INACTIVA = "I"
const ESTATUS_COMPANIA_ACTIVA = "A"

export default function SolicitudCompaniaTenantList({ showLoading, hideLoading }) {
  const CITRUS_ID = 10;

  const { usuario, tienePermiso } = useAuthentication();
  const [where, setWhere] = useState({});
  const [list, setList] = useState([]);
  const history = useHistory();
  const [currentSolicitud, setCurrentSolicitud] = useState({});
  const [fechaCreacionFilterKey, setFechaCreacionFilterKey] = useState(uuid());
  const [fechaAprobacionFilterKey, setFechaAprobacionFilterKey] = useState(uuid());
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas, Message, Warning } = useMessage();
  const [companiaTenant, setCompaniaTenant] = useState([]);
  const [showCancelacionDetalle, setShowCancelacionDetalle] = useState(false);
  const [showActivacionDetalle, setShowActivacionDetalle] = useState(false);
  const [showReActivacionnDetalle, setShowReActivacionDetalle] = useState(false);
  const [showRechazoSolicitudModal, setShowRechazoSolicitudModal] = useState();
  const [razonRechazo, setRazonRechazo] = useState();
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [companiasTenantList, setCompaniasTenantList] = useState([]);
  const [showAdjuntarDocumentosModal, setShowAdjuntarDocumentosModal] = useState();
  const [modal, setModal] = useState(false);
  const [attachmentCount, setAttachmentCount] = useState(0);

  const URLParameters = useQueryParams();
  const esTenant = URLParameters.get("t") === "true";

  const ref = useRef(null);

  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  useEffect(() => {
    buscar();
    return () => {
      cargarCompania();
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  function buscar() {
    const whereWithPaginationValues = {
      ...where,
      ...pagination,
      FechaCreacionInicio: where.RangoFechasCreacion?.fechaInicio,
      FechaCreacionFin: where.RangoFechasCreacion?.fechaFin,
      FechaAprobacionInicio: where.RangoFechasAprobacion?.fechaInicio,
      FechaAprobacionFin: where.RangoFechasAprobacion?.fechaFin,
      EsTenant: esTenant
    };

    SolicitudManager
      .listarSolicitudes(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        try {
          for (let solicitud of res.Data) {
            solicitud["FechaCreacion"] = DateHelper.formatStringDate(
              solicitud["FechaCreacion"],
              false
            );
            solicitud["FechaAprobacion"] = DateHelper.formatStringDate(
              solicitud["FechaAprobacion"],
              false
            ) ?? "";
          }
        } catch (err) { }
        setList(res.Data);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());

    if (!esTenant) {
      const companiasTenantWhere = {
        EsTenant: true,
        EsPaginable: false,
        Estatus: "A"
      };

      CompaniaManager
        .listado(companiasTenantWhere)
        .then((res) => {
          const companiasTenantList = [
            { label: 'Todas', value: 0 },
            ...(res.Data?.map((cia) => ({
              value: cia.Id,
              label: cia.Nombre
            })) || [])
          ];

          setCompaniasTenantList(companiasTenantList);
        })
        .catch((err) => handleException(err));
    }
  }

  const cargarCompania = () => {
    SeguridadManager.buscarCompania()
      .then((data) => {
        setCompaniaTenant(data);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const onReset = () => {
    setFechaCreacionFilterKey(uuid());
    setFechaAprobacionFilterKey(uuid());
  };

  const handleVolverClick = () => {
    if (!esTenant) {
      const urlBase = `/CompaniaList`;
      history.push(urlBase);
    } else {
      const urlBase = `/CompaniaVinculadaList`;
      history.push(urlBase);
    }
  }

  const handleReviewClick = (params) => {
    if (usuario.CompaniaId !== CITRUS_ID) {
      Warning({
        message: `Usuario no tiene permiso.`
      });
      return;
    }

    const { Id } = params;
    const { IdSec } = params;
    const { CompaniaId } = params;
    const { TipoSolicitud } = params;
    const { Estatus } = params;
    const { SolicitudCompaniaId } = params;

    const solicitud = list.find((s) => s.IdSec == IdSec && s.CompaniaId == CompaniaId);

    if (solicitud == undefined) {
      return;
    }

    const DataSolicitud = JSON.parse(solicitud.FormularioJson);

    setCurrentSolicitud({
      ...solicitud,
      DataSolicitud: DataSolicitud
    });

    switch (TipoSolicitud) {
      case TIPO_SOLICITUD_ACTIVACION_LABEL:
        {
          switch (Estatus) {
            case ESTATUS_PENDIENTE_LABEL:
              {
                const dataRequest = btoa(JSON.stringify({Id: IdSec, CompaniaId: CompaniaId}))
                const urlBase = `/CompaniaEdit?request=${true}&requestData=${dataRequest}`;
                history.push(urlBase);
                break;
              }
            case ESTATUS_APROBADO_LABEL:
            case ESTATUS_RECHAZADO_LABEL:
              {
                setShowActivacionDetalle(true);
                break;
              }
          }
          break;
        }
      case TIPO_SOLICITUD_REACTIVACION_LABEL:
        {
          setShowReActivacionDetalle(true);
          break;
        }
      case TIPO_SOLICITUD_CANCELACION_LABEL:
        {
          setShowCancelacionDetalle(true);
          break;
        }
    }
  };

  const handleEditClick = (params) => {
    const { Id } = params;
    const { IdSec } = params;
    const { TipoSolicitud } = params;
    const { Estatus } = params;
    const { SolicitudCompaniaId } = params;

    const solicitud = list.find((s) => s.IdSec == IdSec && s.CompaniaId == usuario.CompaniaId);

    if (solicitud == undefined) {
      return;
    }

    const DataSolicitud = JSON.parse(solicitud.FormularioJson);

    setCurrentSolicitud({
      ...solicitud,
      DataSolicitud: DataSolicitud
    });

    switch (TipoSolicitud) {
      case TIPO_SOLICITUD_ACTIVACION_LABEL:
        {
          switch (Estatus) {
            case ESTATUS_PENDIENTE_LABEL:
              {
                const urlBase = `/CompaniaVinculadaEdit?requestId=${IdSec}`;
                history.push(urlBase);
                break;
              }
            case ESTATUS_APROBADO_LABEL:
            case ESTATUS_RECHAZADO_LABEL:
              {
                setShowActivacionDetalle(true);
                break;
              }
          }
          break;
        }
      case TIPO_SOLICITUD_CANCELACION_LABEL:
        {
          setShowCancelacionDetalle(true);
          break;
        }
      case TIPO_SOLICITUD_REACTIVACION_LABEL:
        {
          setShowReActivacionDetalle(true);
          break;
        }
    }
  };

  const cancelarCompania = (esActivar) => {
    showLoading();

    if (currentSolicitud !== undefined) {
      const { SolicitudCompaniaId } = currentSolicitud;

      const solicitudActualizar = {
        IdSec: currentSolicitud.IdSec,
        CompaniaId: currentSolicitud.CompaniaId,
        Estatus: ESTATUS_APROBADO
      }

      CompaniaManager
        .bloquearCancelarCompania({
          Id: SolicitudCompaniaId,
          statusCode: esActivar ? ESTATUS_COMPANIA_ACTIVA : ESTATUS_COMPANIA_INACTIVA,
          EsSolicitudTenant: true,
          SolicitudActualizar: solicitudActualizar
        })
        .then((res) => {
          Message({ message: "Solicitud aprobada existosamente." })
        })
        .catch((err) => {
          handleException(err);
        })
        .finally(() => {
          setShowReActivacionDetalle(false);
          setShowCancelacionDetalle(false);
          hideLoading();
          buscar();
        });
    }
  };

  const rechazarSolicitudCompania = () => {
    showLoading();

    if (!razonRechazo) {
      hideLoading();
      Warning({
        message: `Debe indicar la razón de rechazo de la solicitud.`
      });
      return;
    }

    SolicitudManager
      .actualizarSolicitudCompaniaTenant({
        IdSec: currentSolicitud.IdSec,
        CompaniaId: currentSolicitud.CompaniaId,
        Estatus: ESTATUS_RECHAZADO,
        RazonRechazoSolicitud: razonRechazo
      })
      .then((res) => {
        Message({ message: "Solicitud rechazada exitosamente." })
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        hideLoading();
        setShowReActivacionDetalle(false);
        setShowCancelacionDetalle(false);
        setShowRechazoSolicitudModal(false);
        setRazonRechazo();
        buscar();
      });
  };

  const ActivacionDetalleSideBar = () => {
    return (
      <Simplebar
        ref={ref}
        backdrop={true}
        placement={"end"}
        portal={false}
        visible={showActivacionDetalle}
        setShow={(e) => {
          setShowActivacionDetalle(e);
        }}
        useLoading={true}
        title="Solicitud de Activación"
        size="xl"
        btnLeft={{
          show: false
        }}
        btnRight={{
          show: false
        }}
      >
        <InputSidebarContainer label="Solicitud">
          <SectionRow>
            <InputSidebarContainer label="ID">
              <Form.Control
                disabled={true}
                value={currentSolicitud.SolicitudCompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Código">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.Codigo ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <InputSidebarContainer label="RNC">
            <Form.Control
              disabled={true}
              value={currentSolicitud?.DataSolicitud?.RNC ?? ""}
            >
            </Form.Control>
          </InputSidebarContainer>

          <InputSidebarContainer label="Nombre">
            <Form.Control
              disabled={true}
              value={currentSolicitud?.DataSolicitud?.Nombre ?? ""}
            >
            </Form.Control>
          </InputSidebarContainer>

          <InputSidebarContainer label="Razon Social">
            <Form.Control
              disabled={true}
              value={currentSolicitud?.DataSolicitud?.RazonSocial ?? ""}
            >
            </Form.Control>
          </InputSidebarContainer>

          <InputSidebarContainer label="Dirección">
            <Form.Control
              disabled={true}
              value={currentSolicitud?.DataSolicitud?.DireccionLinea1 ?? ""}
            >
            </Form.Control>
          </InputSidebarContainer>

          <SectionRow>
            <InputSidebarContainer label="Teléfono Principal">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.TelefonoPrincipal ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Extensión 1">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.Extension1 ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <SectionRow>
            <InputSidebarContainer label="Teléfono Secundario">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.TelefonoSecundario ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Extensión 2">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.Extension2 ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <SectionRow>
            <InputSidebarContainer label="Correo">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.Email ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Fax">
              <Form.Control
                disabled={true}
                value={currentSolicitud?.DataSolicitud?.Fax ?? ""}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <InputSidebarContainer label="Página Web">
            <Form.Control
              disabled={true}
              value={currentSolicitud?.DataSolicitud?.PaginaWeb ?? ""}
            >
            </Form.Control>
          </InputSidebarContainer>

          <SectionRow triple={true}>
            <InputSidebarContainer label="Color Primario">
              <Form.Control
                disabled={true}
                type="color"
                value={`#${currentSolicitud?.DataSolicitud?.Color1}` ?? "#F16101"}
              />
            </InputSidebarContainer>

            <InputSidebarContainer label="Color Secundario">
              <Form.Control
                disabled={true}
                type="color"
                value={`#${currentSolicitud?.DataSolicitud?.Color2}` ?? "#8AA8B0"}
              />
            </InputSidebarContainer>

            <InputSidebarContainer label="Fondo Logo">
              <Form.Control
                disabled={true}
                type="color"
                value={`#${currentSolicitud?.DataSolicitud?.Color3}` ?? "#FFFFFF"}
              />
            </InputSidebarContainer>
          </SectionRow>
        </InputSidebarContainer>

        <InputSidebarContainer label="Documentos adjuntos">
          <Attachments
            readonly={
              (usuario.CompaniaId != currentSolicitud.CompaniaId) ||
              currentSolicitud.Estatus != ESTATUS_PENDIENTE_LABEL
            }
            showLoading={() => { }}
            hideLoading={() => { }}
            companiaId={currentSolicitud.CompaniaId}
            fuente="SolicitudesCompaniaTenant"
            modulo="ECF"
            referencia={currentSolicitud.IdSec}
            ocultarHeader={true}
            modal={modal}
            setModal={setModal}
            setAttachmentCount={setAttachmentCount}
          />
        </InputSidebarContainer>

        {currentSolicitud.Estatus == ESTATUS_RECHAZADO_LABEL &&
          <InputSidebarContainer label="Razón de Rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={true}
              value={currentSolicitud.RazonRechazoSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>
        }

        <InputSidebarContainer label="Información del Solicitante">
          <SectionRow triple={true}>
            <InputSidebarContainer label="ID Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuario}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Correo">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioEmail}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <SectionRow>
            <InputSidebarContainer label="ID Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.NombreCompaniaTenant}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>
        </InputSidebarContainer>
      </Simplebar>
    )
  };

  const ReactivacionDetalleSideBar = () => {
    return (
      <Simplebar
        ref={ref}
        backdrop={true}
        placement={"end"}
        portal={false}
        visible={showReActivacionnDetalle}
        setShow={(e) => {
          setShowReActivacionDetalle(e);
        }}
        useLoading={true}
        title="Solicitud de Re-Activación"
        size="xl"
        btnLeft={(usuario.CompaniaId == CITRUS_ID && tienePermiso(Permisos.SolicitudTenant.EVALUAR)) &&
          currentSolicitud.Estatus === ESTATUS_PENDIENTE_LABEL ? {
          show: true,
          message: "Rechazar",
          isComponent: true,
          size: "45px",
          height: "24px",
          width: "24px",
          iconName: "cancel",
          func: () => {
            setShowRechazoSolicitudModal(true);
          }
        } : { show: false }}
        btnRight={(usuario.CompaniaId == CITRUS_ID && tienePermiso(Permisos.SolicitudTenant.EVALUAR)) &&
          currentSolicitud.Estatus === ESTATUS_PENDIENTE_LABEL ? {
          show: true,
          message: "Aprobar",
          isComponent: true,
          size: "45px",
          height: "24px",
          width: "24px",
          iconName: "check",
          func: () => {
            cancelarCompania(true);
            setShowReActivacionDetalle(false);
          }
        } : { show: false }}
      >
        <InputSidebarContainer label="Compañía">
          <SectionRow>
            <InputSidebarContainer label="ID">
              <Form.Control
                disabled={true}
                value={currentSolicitud.SolicitudCompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Código">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CodigoSolicitud}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <InputSidebarContainer label="RNC">
            <Form.Control
              disabled={true}
              value={currentSolicitud.RNCSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>

          <InputSidebarContainer label="Nombre">
            <Form.Control
              disabled={true}
              value={currentSolicitud.NombreCompaniaSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>
        </InputSidebarContainer>

        <InputSidebarContainer>
          <Attachments
            readonly={
              (usuario.CompaniaId != currentSolicitud.CompaniaId) ||
              currentSolicitud.Estatus != ESTATUS_PENDIENTE_LABEL
            }
            showLoading={() => { }}
            hideLoading={() => { }}
            companiaId={currentSolicitud.CompaniaId}
            fuente="SolicitudesCompaniaTenant"
            modulo="ECF"
            referencia={currentSolicitud.IdSec}
            ocultarHeader={false}
            label={"Documentos adjuntos"}
            containerFluid={true}
            containerClassName="p-0"
            modal={modal}
            setModal={setModal}
            setAttachmentCount={setAttachmentCount}
          />
        </InputSidebarContainer>

        {currentSolicitud.Estatus == ESTATUS_RECHAZADO_LABEL &&
          <InputSidebarContainer label="Razón de Rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={true}
              value={currentSolicitud.RazonRechazoSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>
        }

        <InputSidebarContainer label="Información del Solicitante">
          <SectionRow triple={true}>
            <InputSidebarContainer label="ID Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuario}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Correo">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioEmail}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <SectionRow>
            <InputSidebarContainer label="ID Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.NombreCompaniaTenant}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>
        </InputSidebarContainer>
      </Simplebar>
    )
  };

  const CancelacionDetalleSideBar = () => {
    return (
      <Simplebar
        ref={ref}
        backdrop={true}
        placement={"end"}
        portal={false}
        visible={showCancelacionDetalle}
        setShow={(e) => {
          setShowCancelacionDetalle(e);
        }}
        useLoading={true}
        title="Solicitud de Cancelación"
        size="xl"
        btnLeft={(usuario.CompaniaId == CITRUS_ID && tienePermiso(Permisos.SolicitudTenant.EVALUAR)) &&
          currentSolicitud.Estatus === ESTATUS_PENDIENTE_LABEL ? {
          show: true,
          message: "Rechazar",
          isComponent: true,
          size: "45px",
          height: "24px",
          width: "24px",
          iconName: "cancel",
          func: () => {
            setShowRechazoSolicitudModal(true);
          }
        } : { show: false }}
        btnRight={(usuario.CompaniaId == CITRUS_ID && tienePermiso(Permisos.SolicitudTenant.EVALUAR)) &&
          currentSolicitud.Estatus === ESTATUS_PENDIENTE_LABEL ? {
          show: true,
          message: "Aprobar",
          isComponent: true,
          size: "45px",
          height: "24px",
          width: "24px",
          iconName: "check",
          func: () => {
            cancelarCompania();
            setShowCancelacionDetalle(false);
          }
        } : { show: false }}
      >
        <InputSidebarContainer label="Compañía a cancelar">
          <SectionRow>
            <InputSidebarContainer label="ID Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.SolicitudCompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Código">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CodigoSolicitud}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <InputSidebarContainer label="RNC">
            <Form.Control
              disabled={true}
              value={currentSolicitud.RNCSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>

          <InputSidebarContainer label="Nombre">
            <Form.Control
              disabled={true}
              value={currentSolicitud.NombreCompaniaSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>
        </InputSidebarContainer>

        <InputSidebarContainer label="Razón de Cancelación">
          <Form.Control
            as="textarea"
            rows={5}
            style={{ resize: "vertical" }}
            disabled={true}
            value={currentSolicitud.RazonCancelacion}
          >
          </Form.Control>
        </InputSidebarContainer>

        <InputSidebarContainer>
          <Attachments
            readonly={
              (usuario.CompaniaId != currentSolicitud.CompaniaId) ||
              currentSolicitud.Estatus != ESTATUS_PENDIENTE_LABEL
            }
            showLoading={() => { }}
            hideLoading={() => { }}
            companiaId={currentSolicitud.CompaniaId}
            fuente="SolicitudesCompaniaTenant"
            modulo="ECF"
            referencia={currentSolicitud.IdSec}
            ocultarHeader={false}
            label={"Documentos adjuntos"}
            containerFluid={true}
            containerClassName="p-0"
            modal={modal}
            setModal={setModal}
            setAttachmentCount={setAttachmentCount}
          />
        </InputSidebarContainer>

        {currentSolicitud.Estatus == ESTATUS_RECHAZADO_LABEL &&
          <InputSidebarContainer label="Razón de Rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={true}
              value={currentSolicitud.RazonRechazoSolicitud}
            >
            </Form.Control>
          </InputSidebarContainer>
        }

        <InputSidebarContainer label="Información del Solicitante">
          <SectionRow triple={true}>
            <InputSidebarContainer label="ID Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Usuario">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuario}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Correo">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CrearUsuarioEmail}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>

          <SectionRow>
            <InputSidebarContainer label="ID Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.CompaniaId}
              >
              </Form.Control>
            </InputSidebarContainer>

            <InputSidebarContainer label="Compañía">
              <Form.Control
                disabled={true}
                value={currentSolicitud.NombreCompaniaTenant}
              >
              </Form.Control>
            </InputSidebarContainer>
          </SectionRow>
        </InputSidebarContainer>
      </Simplebar>
    )
  };

  const rechazarSolicitudModal = (
    <ModalContainer
      showModal={showRechazoSolicitudModal}
      size="lg"
      title="Rechazar Solicitud"
      btnGrabar={{
        label: "Grabar",
        show: true
      }}
      cerrar={() => {
        setShowRechazoSolicitudModal(false);
      }}
      grabar={() => {
        rechazarSolicitudCompania();
      }}
    >
      <EditSection>
        <Row>
          <InputSidebarContainer label="Razón de Rechazo">
            <Form.Control
              as="textarea"
              rows={5}
              style={{ resize: "vertical" }}
              disabled={false}
              value={razonRechazo}
              onChange={(e) =>
                setRazonRechazo(e.target.value)
              }
            >
            </Form.Control>
          </InputSidebarContainer>
        </Row>
      </EditSection>
    </ModalContainer>
  )

  return (
    <>
      {showRechazoSolicitudModal && rechazarSolicitudModal}

      <CancelacionDetalleSideBar />
      <ActivacionDetalleSideBar />
      <ReactivacionDetalleSideBar />

      <ListHeader
        titulo="Solicitudes de Compañías"
        volver={handleVolverClick}
      />

      <GridView
        dataSource={list}
        where={where}
        setWhere={setWhere}
        setPagination={setPagination}
        onPageIndexChanging={onPageIndexChanging}
        pagination={pagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        onReset={onReset}
        height="78vh"
        primaryKey="Id"
      >
        <GridView.Column
          isField
          width="100px"
          showClearFilter={true}
          bodyRenderer={(row) => {
            return (
              <>
                {(usuario.Compania.EsTenant && tienePermiso(Permisos.SolicitudTenant.EDITAR)) && (
                  <div className="float-right">
                    <IconButton
                      onClick={() =>
                        handleEditClick({
                          Id: row.Id,
                          IdSec: row.IdSec,
                          CompaniaId: row.CompaniaId,
                          TipoSolicitud: row.TipoSolicitud,
                          Estatus: row.Estatus,
                          SolicitudCompaniaId: row.SolicitudCompaniaId
                        })
                      }
                    >
                      <ToolTip message={row.Estatus == ESTATUS_PENDIENTE_LABEL ? "Editar" : "Ver"}>
                        <div>
                          {row.Estatus == ESTATUS_PENDIENTE_LABEL ? (
                            <SvgComponent
                              iconName="pencil"
                              height="25px"
                              width="25px"
                            />
                          ) : (
                            <SvgComponent
                              iconName="view"
                              height="25px"
                              width="25px"
                            />
                          )}
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div >
                )}

                {(usuario.CompaniaId == CITRUS_ID && tienePermiso(Permisos.SolicitudTenant.EVALUAR)) && (
                  <div className="float-right">
                    <IconButton
                      onClick={() =>
                        handleReviewClick({
                          Id: row.Id,
                          IdSec: row.IdSec,
                          CompaniaId: row.CompaniaId,
                          TipoSolicitud: row.TipoSolicitud,
                          Estatus: row.Estatus,
                          SolicitudCompaniaId: row.SolicitudCompaniaId
                        })
                      }
                    >
                      <ToolTip message="Evaluar">
                        <div>
                          <SvgComponent
                            iconName="view"
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </ToolTip>
                    </IconButton>
                  </div>
                )}
              </>
            )
          }}
        >
        </GridView.Column >
        <GridView.Column
          headerText="Id"
          dataField="IdSec"
          sortExpression="Id"
          width="100px"
        />
        {!esTenant &&
          <GridView.Column
            headerText="Solicitante"
            dataField="NombreCompaniaTenant"
            sortExpression="NombreCompaniaTenant"
            width="200px"
            filterRenderer={() => {
              return (
                <Select
                  className="react-select primary"
                  options={companiasTenantList}
                  value={companiasTenantList.filter(function (option) {
                    return (
                      option.value === (
                        where.CompaniaId ?
                          where.CompaniaId
                          : companiasTenantList[0].value
                      )
                    )
                  })}
                  name="CompaniaId"
                  onChange={(e) =>
                    setWhere({
                      ...where,
                      CompaniaId: e.value
                    })
                  }
                />
              )
            }}
          />
        }
        <GridView.Column
          headerText="Tipo Solicitud"
          dataField="TipoSolicitud"
          sortExpression="TipoSolicitud"
          width="250px"
          filterRenderer={() => {
            return (
              <Select
                className="react-select primary"
                options={TIPO_SOLICITUD_TENANT_LIST}
                value={TIPO_SOLICITUD_TENANT_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (where.TipoSolicitud ? where.TipoSolicitud : TIPO_SOLICITUD_TENANT_LIST[0].value)
                  );
                })}
                name="TipoSolicitud"
                onChange={(e) =>
                  setWhere({
                    ...where,
                    TipoSolicitud: e.value
                  })
                }
              />
            )
          }}
        />
        <GridView.Column
          headerText="Compañía afectada"
          dataField="NombreCompaniaSolicitud"
          sortExpression="NombreCompaniaSolicitud"
          width="200px"
        />
        <GridView.Column
          headerText="Estatus"
          dataField="Estatus"
          sortExpression="Estatus"
          width="160px"
          filterRenderer={() => {
            return (
              <Select
                className="react-select primary"
                options={ESTATUS_SOLICITUD_TENANT_LIST}
                value={ESTATUS_SOLICITUD_TENANT_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (where.Estatus ?
                      where.Estatus :
                      ESTATUS_SOLICITUD_TENANT_LIST[0].value
                    )
                  );
                })}
                name="Estatus"
                onChange={(e) =>
                  setWhere({
                    ...where,
                    Estatus: e.value
                  })
                }
              />
            );
          }}
        />

        <GridView.Column
          date
          hideFilter
          headerText="Fecha de Registro"
          dataField="FechaCreacion"
          sortExpression="FechaCreacion"
          width="230px"
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={fechaCreacionFilterKey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={where?.RangoFechasCreacion?.fechaInicio || ""}
                fechaFinOriginal={where?.RangoFechasCreacion?.fechaFin || ""}
                onChange={(e) => {
                  const updatedRange = { ...e };

                  if (updatedRange.fechaInicio) {
                    const start = new Date(updatedRange.fechaInicio);
                    start.setHours(0, 0, 0, 0);
                    updatedRange.fechaInicio = start;
                  }

                  if (updatedRange.fechaFin) {
                    const end = new Date(updatedRange.fechaFin);
                    end.setHours(23, 59, 59, 0);
                    updatedRange.fechaFin = end;
                  }

                  onInputChange({
                    target: { name: "RangoFechasCreacion", value: updatedRange }
                  })
                }}
              />
            );
          }}
        />

        <GridView.Column
          date
          hideFilter
          headerText="Fecha de Aprobación"
          dataField="FechaAprobacion"
          sortExpression="FechaAprobacion"
          width="230px"
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={fechaAprobacionFilterKey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={where?.RangoFechasAprobacion?.fechaInicio || ""}
                fechaFinOriginal={where?.RangoFechasAprobacion?.fechaFin || ""}
                onChange={(e) => {
                  const updatedRange = { ...e };

                  if (updatedRange.fechaInicio) {
                    const start = new Date(updatedRange.fechaInicio);
                    start.setHours(0, 0, 0, 0);
                    updatedRange.fechaInicio = start;
                  }

                  if (updatedRange.fechaFin) {
                    const end = new Date(updatedRange.fechaFin);
                    end.setHours(23, 59, 59, 0);
                    updatedRange.fechaFin = end;
                  }

                  onInputChange({
                    target: { name: "RangoFechasAprobacion", value: updatedRange }
                  })
                }}
              />
            );
          }}
        />
      </GridView >
    </>
  )
}